<template>
  <div class="layout">
  <Layout>
    <AdminTop />
    <Layout>
    <Sider hide-trigger :style="{background: '#fff'}">
    <AdminMenu />
  </Sider>
    <Layout :style="{padding: '0 24px 24px'}">
      <AdminBread />
      <Content :style="{padding: '24px', minHeight: '280px', background: '#fff'}">
        <!-- <List item-layout="vertical"  style="padding: 12px; border: solid 1px #dcdee2; border-top: none;">
          <ListItem v-for="item in workBriefings" :key="item.id">
            <ListItemMeta>
              <template #title><a href="#"><b>{{ item.title }}</b></a></template>
              
            </ListItemMeta>
            
            <template #action>
              <li>
                <Icon type="ios-chatbubbles-outline" /> 作者 <b>{{ item.createUserName }}</b>
              </li>
              <li>
                <Icon type="ios-thumbs-up-outline" /> 发布日期 <b>{{ item.createTime }}</b>
              </li>
              <li>
                <Button type="error" @click="deleteArticle(item.id)">删除</Button>
              </li>
            </template>
          </ListItem>
        </List> -->
        <Table border :columns="columns" :data="articles">
            <template #title="{ row }">
                <strong>{{ row.title }}</strong>
            </template>
            <template #action="{ row }">
                <Button type="primary" size="small" style="margin-right: 5px" @click="gotoEdit(row)">修改</Button>
                <Button type="error" size="small" @click="deleteConfirm(row.id)">删除</Button>
            </template>
        </Table>
        <div id="pager"><Page :total="num" @on-change="pageChange" show-total /></div>
      </Content>
    </Layout>
    </Layout>
  </Layout>
  <Modal
    v-model="delModal"
    title="删除确认"
    @on-ok="deleteArticle">
    <p>内容删除后不能恢复。</p>
    <p>您确认要删除吗？</p>
  </Modal>
  </div>
</template>
<script>
import AdminTop from '../../components/AdminTop.vue'
import AdminMenu from '../../components/AdminMenu.vue'
import AdminBread from '../../components/AdminBread.vue'
import global from '@/utils/global'
import axios from 'axios'
export default {
  components: {
    AdminTop,
    AdminMenu,
    AdminBread,
  },

  data () {
      return {
        user: null,
        
        delModal: false,
        deleteId: 0,
        page: 1,
        num: 0,
        articles:[],
        columns: [
          {
              title: '标题',
              slot: 'title',
              minWidth: 120
          },
          {
              title: '作者',
              key: 'createUserName',
              width: 130
          },
          {
              title: '发布时间',
              key: 'createTime',
              width: 200
          },
          {
              title: '所属分类',
              key: 'categoryName',
              width: 100
          },
          {
              title: 'Action',
              slot: 'action',
              width: 140,
              align: 'center'
          }
        ],
      }
    },
    mounted() {
      this.initUser()
      this.workBriefing()
    },
    methods: {
      //初始化用户信息
            initUser() {
        let userStr = localStorage.getItem("user")
        if(userStr!=null) {
          this.user = JSON.parse(userStr)
        } else {
          this.$router.push({path: '/'})
        }
      },

      workBriefing() {
        let vm = this
        let category = this.$route.query.category
        axios({
          method: 'post',
          url: global.restUrl + '/api/web/article/v1.0/list',
          data: {
            categoryCode: category,
            limit:10,
            page: vm.page
          }
        }).then(function (response) {
          let success = response.data.success
          if(success) {
            let data = response.data.data
            if(data.list!=null) {
              vm.articles = data.list
            } else {
              vm.articles = []
            }
            vm.num = data.num
          }
        });
      },
      //翻页
      pageChange(page) {
        this.page = page
        this.workBriefing()
      },
      //删除确认
      deleteConfirm(id) {
        this.deleteId = id
        this.delModal=true
      },
      //删除
      deleteArticle() {      
        let vm = this
        axios({
          method: 'post',
          url: global.restUrl + '/api/web/article/v1.0/delete',
          data: {
            id: vm.deleteId
          },
          headers: {
            token: vm.user.token
          }
        }).then(function (response) {
          let success = response.data.success
          if(success) {
            vm.workBriefing()
          }
        });
      },
      //编辑
      gotoEdit(item) {
        this.$router.push({path: '/admin/article/edit', query: {id: item.id}});
      }
    }
}
</script>
